//External Libraries
import * as React from "react";
import mkTracker from "ouisys-clients/dist/pacman/record";
import { defineMessages } from "ouisys-clients/dist/clients/common-components/Intl";
import HOC, {
  initialState,
  mockedPINState,
  mockedCompletedState,
  HOCProps,
  match
} from "ouisys-clients/dist/clients/tallyman.v1-pin/HOC";
import { TranslationProvider, Translate, legals } from "./localization/index";
import { getConfig } from "ouisys-phone-input/dist/common/PhoneInput"

//Components
import Disclaimer from "ouisys-clients/dist/clients/legal-components/disclaimers";
import TopLegals from "ouisys-clients/dist/clients/legal-components/top-legals";
import PricePoint from "ouisys-clients/dist/clients/legal-components/price-point";
import PreLander from "./components/PreLander";

import PhoneNumberEntryStep from "./components/PhoneNumberEntryStep";
import PINEntryStep from "./components/PINEntryStep";
import ThankYouStep from "./components/ThankYouStep";

//Utilities
import searchToObject from "./utils/searchToObject";

//Styling
import "./Root.scss"
import { mockedSuccessState } from "ouisys-clients/dist/clients/tallyman.v1-click2sms/HOC";

//Error messages Messages which might come from backend
const defaultMessages = defineMessages({
  InvalidMSISDN: {
    id: "InvalidMSISDN",
    defaultMessage: "This mobile number is incorrect, try again",
  },
  AlreadySubscribed: {
    id: "AlreadySubscribed",
    defaultMessage: "You are already a subscriber!",
  },
  UnknownError: {
    id: "UnknownError",
    defaultMessage: "An unknown error occurred.",
  },
  InvalidPIN: {
    id: "InvalidPIN",
    defaultMessage: "Please enter the correct PIN that you received on your phone",
  },
  TooEarly: {
    id: "TooEarly",
    defaultMessage: "You must first submit a mobile number",
  },
  didnt_receive_pin_yet: {
    id: "didnt_receive_pin_yet",
    defaultMessage: "TODO: didnt_receive_pin_yet"
  }
});
const tracker = mkTracker(
  typeof window != "undefined" ? window : null,
  "xx",
  process.env.page
);

const imgLogo = require("../src/assets/imgs/striker_logo.svg");
const imgScene = require("../src/assets/imgs/video_bg.jpg");
const imgMtn = require("../src/assets/imgs/mtn.svg");

function Root(props: HOCProps) {

  const [locale, setLocale] = React.useState("en")
  const [msisdn, setMsisdn] = React.useState(getConfig(process.env.country).commonPrefix)
  const [skipPrelander, setSkipPrelander] = React.useState(true)
  const [playerPlay, setPlayerPlay] = React.useState("")
  const [activeHolder, setActiveHolder] = React.useState("")

  React.useEffect(() => {
    //Show or hide pre-lander
    const search = searchToObject();
    if (search["skip-prelander"]) {
      const skip = (search["skip-prelander"] === "true") ? true : false
      if (skip) {
        setSkipPrelander(true)
      }
    }
  }, [])


  function playVideo() {

    setPlayerPlay("active");
    tracker.advancedInPreFlow("play-button-click");

    setTimeout(() => {

      setActiveHolder("active");

      setPlayerPlay("active pause");

    }, 500)

  }

  return (
    <TranslationProvider locale={locale}>
      <div className="container">

          {/* pre-lander */}
          {
            !skipPrelander &&
            <PreLander />
          }


          {/* top-legals */}
          <TopLegals className="top-legals" locale={locale} legals={legals} />

          <div className="header_area">

            <img src={imgLogo} alt="" />

          </div>

          <div className={`center-align ${playerPlay}`} onClick={playVideo}>

            <span className="video_area">

              <img src={imgScene} alt="" />

            </span>

            <span id="controls">
              <span id="load_bar"></span>
            </span>

            <h3><strong>stream ad free</strong> videos</h3>

            {/* price-point */}
            <PricePoint className="price-point" locale={locale} legals={legals} />

            <img src={imgMtn} alt="" className="mtn"/>

          </div>

          <div className={`holder fadeIn ${activeHolder}`}>

            <div className="holder-content">

              {match({
                msisdnEntry: rds => (
                  <PhoneNumberEntryStep
                    msisdn={msisdn}
                    rds={rds}
                    onEnd={(msisdn, extraParams) => {
                      setMsisdn(msisdn);
                      props.actions.submitMSISDN(
                        window,
                        null,
                        msisdn,
                        extraParams
                      );
                    }}
                  />
                ),
                pinEntry: rds => (
                  <PINEntryStep
                    onEnd={pin => props.actions.submitPIN(pin)}
                    backToStart={() => props.actions.backToStart()}
                    msisdn={msisdn}
                    rds={rds}
                  />
                ),
                completed: ({ finalUrl }) => (
                  <ThankYouStep finalUrl={finalUrl} />
                )
              })(props.currentState)}

            </div>

          </div>

          <div className="logos_area"></div>

          <div className="legals">

            {/* disclaimers */}
            <Disclaimer className="disclaimer" locale={locale} legals={legals} />

          </div>

        </div>

    </TranslationProvider>
  );
}


export default HOC(tracker, Root)(initialState);



